"use strict";
export default {
  "rar": "compress",
  "zip": "compress",
  "iso": "compress",
  "7z": "compress",
  "arj": "compress",
  "doc": "word",
  "docx": "word",
  "ppt": "ppt",
  "pptx": "ppt",
  "xls": "xls",
  "xlsx": "xls",
  "vsdpot": "TXT",
  "pps": "TXT",
  "rtf": "TXT",
  "txt": "TXT",
  "pot": "TXT",
  "dot": "TXT",
  "dotx": "TXT",
  "ppsx": "TXT",
  "pdf": "pdf",
  "jpg": "pic",
  "gif": "pic",
  "bmp": "pic",
  "png": "pic",
  "jpeg": "pic",
  "mp3": "audio",
  "mp4": "video",
  "avi": "video",
  "movwmv": "video",
  "3gp": "video",
  "mkv": "video",
  "rmvb": "video"
};
